<template>
  <div>

    <TitlePage :title="$t('customers')"></TitlePage>

    <div class="mt-5">
      <p>Duplicati per email</p>
      <v-data-table :headers="headers" :items="items" item-key="_id" class="elevation-1" :search="search">
        <template v-slot:top>
          <v-text-field
              v-model="search"
              class="mx-4"
              :placeholder="$t('search')"
          ></v-text-field>
        </template>
        <template v-slot:item.action="{ item }">
          <div @click="openDuplicateModal(item, 'email')" style="cursor: pointer">
            <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>{{ $t('details') }}
          </div>
        </template>
      </v-data-table>


      <p class="mt-5">Duplicati per numero di telefono</p>
      <v-data-table :headers="headers_phone" :items="items_phone" item-key="_id" class="elevation-1" :search="search_phone">
        <template v-slot:top>
          <v-text-field
              v-model="search_phone"
              class="mx-4"
              :placeholder="$t('search')"
          ></v-text-field>
        </template>
        <template v-slot:item.action="{ item }">
          <div @click="openDuplicateModal(item, 'phone')" style="cursor: pointer">
            <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>{{ $t('details') }}
          </div>
        </template>
      </v-data-table>
    </div>

    <div class="text-center">
      <v-dialog v-model="modal_duplicate" width="1200">
        <v-card>

          <div class="pa-5">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
<!--                  <th class="text-left">-->
<!--                    Id-->
<!--                  </th>-->
                  <th class="text-left">
                    Nome
                  </th>
                  <th class="text-left">
                    Email
                  </th>
                  <th class="text-left">
                    Telefono
                  </th>
                  <th class="text-left">
                    Prenotazioni Completate
                  </th>
                  <th class="text-left">
                    Status
                  </th>
                  <th class="text-left">
                    Registrato il
                  </th>
                  <th class="text-left">
                    Ultimo aggiornamento
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user in item_duplicate.docs" :key="user._id">
<!--                  <td>{{ user._id }}</td>-->
                  <td>{{ user.name }} {{ user.surname }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.phone }}</td>
                  <td>{{ user.bookings && user.bookings.bookings_count_completed ? user.bookings.bookings_count_completed : user.bookings_completed }}</td>
                  <td>{{ (user.active) ? 'ATTIVO' : 'DISATTIVATO' }}</td>
                  <td>{{ new Date(user.created_at).toLocaleString() }}</td>
                  <td>{{ new Date(user.updated_at).toLocaleString() }}</td>
                  <td><v-icon dense color="primary" class="mr-3"  @click="details(user._id)" title="Dettagli">mdi-file-find</v-icon></td>
                  <td><v-icon dense color="primary" class="mr-3"  @click="edit(user._id)" title="Modifica">mdi-file-edit</v-icon></td>
                  <td><v-icon dense color="primary" class="mr-3"  @click="confirmRemove(user._id)" title="Elimina">mdi-delete</v-icon></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>


          <v-divider></v-divider>

          <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="item_duplicate={}; duplicate_type=''; modal_duplicate=false;">
              {{ $t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>


  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";

export default {
  name: 'CustomersDuplicate',
  components: {ModalDelete, TitlePage},
  data() {
    return {
      pathEdit: '/customers/edit/',
      pathDetails: '/customers/details/',
      search: '',
      search_phone: '',
      headers: [
        { text: 'Email', align: 'start', value: '_id'},
        { text: 'N° Account', align: 'start', value: 'count'},
        { text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      headers_phone: [
        { text: 'Telefono', align: 'start', value: 'phone'},
        { text: 'N° Account', align: 'start', value: 'count'},
        { text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_phone: [],
      modal_duplicate: false,
      item_duplicate: null,
      duplicate_type: '',
      modalDelete: false
    };
  },
  async created(){
    await this.makeSearch()
  },
  computed: {
    ...mapGetters({
      'getFilter':'customers/getFilter',
      'getUser':'user/getUser'
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'customers/duplicates',
      'deleteItem': 'customers/delete',
    }),

    edit(id){
      let url = this.$router.resolve(this.pathEdit+id)
      window.open(url.href, '_blank');
    },

    details(id){
      let url = this.$router.resolve(this.pathDetails+id)
      window.open(url.href, '_blank');
    },

    openDuplicateModal(item, type){
      this.item_duplicate = item
      this.duplicate_type = type
      this.modal_duplicate = true
    },

    async makeSearch() {
      this.setLoading(true);
      let results = await this.getItems();
      this.items = results.email
      this.items_phone = results.phone

      this.setLoading(false);
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    async removeHandler(mode){
      if(this.typeDelete === 'single'){
        await this.remove(mode)
      }else if(this.typeDelete === 'massive'){
        // await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        let result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          this.item_duplicate.docs = this.item_duplicate.docs.filter((el) => el._id.toString() !== this.ids_to_delete[0].toString())

          await this.makeSearch()
          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },

    async updateSingleStatus(item){

      await this.setLoading(true);
      let result = await this.updateItem({id:item._id, item: {active: item.active, email: item.email}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })
      }
    },
  },
  mounted() {

  },
}
</script>
